import { render, staticRenderFns } from "./UserProfileImageReview.vue?vue&type=template&id=03af4b98&scoped=true"
import script from "./UserProfileImageReview.vue?vue&type=script&lang=js"
export * from "./UserProfileImageReview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03af4b98",
  null
  
)

export default component.exports